import { z } from 'zod';

export const xeroSignupValidationSchema = z.object({
  user_name: z
    .string()
    .min(1, 'Username is required')
    .max(100, 'Username cannot be longer than 100 characters'),
  organization_name: z
    .string()
    .min(1, 'Organization name is required')
    .max(100, 'Organization name cannot be longer than 100 characters'),
  email: z.string().email().min(1, 'Email is required'),
  phone_number: z
    .string()
    .max(15, 'Phone number cannot be longer than 15 characters')
    .optional(),
  password: z
    .string()
    .max(50, 'Password cannot be longer than 50 characters')
    .optional(),
  isTermsAccepted: z.boolean().refine((val) => val === true, {
    message: 'You must accept the terms to proceed',
  }),
});
